import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Giovanni Rampazzo. P.IVA 05625510283 - Tutti i diritti riservati.</p>
        <div className="social-links">
           <Link to="/privacy">Privacy Policy</Link>
           <Link to="/cookie">Cookie Policy</Link>
           <a href="https://www.linkedin.com/in/giovanni-rampazzo93/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;